module.exports = __webpack_public_path__ + "img/copy_disabled.9df9c312.svg";